/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const Hospital = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 74 55">
            <rect x="26.7549" width="21.5299" height="15.3514" fill="currentColor" />
            <rect x="11.5713" y="13.5" width="50.774" height="38.3704" rx="0.677303" fill="currentColor" />
            <path
                d="M8.67882 52.7732H66.536"
                stroke="currentColor"
                strokeWidth="2.827"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.6543 39.9604H41.0676V50.829H33.6543V39.9604Z"
                fill="white"
            />
            <rect x="40.5" y="28.9282" width="5.52273" height="5.59286" fill="white" />
            <rect x="28.9287" y="28.9282" width="5.52273" height="5.59286" fill="white" />
            <rect x="17.3574" y="28.9282" width="5.52273" height="5.59286" fill="white" />
            <rect x="52.0713" y="28.9282" width="5.52273" height="5.59286" fill="white" />
            <rect x="40.5" y="19.2856" width="5.52273" height="5.59286" fill="white" />
            <rect x="28.9287" y="19.2856" width="5.52273" height="5.59286" fill="white" />
            <rect x="17.3574" y="19.2856" width="5.52273" height="5.59286" fill="white" />
            <rect x="52.0713" y="19.2856" width="5.52273" height="5.59286" fill="white" />
            <rect x="36.0107" y="2.89258" width="3.86591" height="11.745" fill="white" />
            <rect x="32.1445" y="6.80713" width="11.5977" height="3.915" fill="white" />
        </SvgIcon>

    );
};

Hospital.defaultProps = { className: '' };

Hospital.propTypes = { className: PropTypes.string };

export default Hospital;
